
import { defineComponent, SetupContext, PropType } from "vue";
import CommonRecipeListItem from "@/components/commonRecipe/CommonRecipeListItem.vue";
import { CommonRecipe } from "@/types/commonRecipe";
import NativeClient from "@/client/native-client";

export default defineComponent({
  name: "CommonRecipeList",
  components: { CommonRecipeListItem },
  props: {
    /**
     * レシピリストに表示するデータの配列
     */
    recipes: {
      type: Array as PropType<CommonRecipe[]>,
      default: () => []
    },
    /**
     * 項目の選択のボタン表示 0:ボタンなし、1:削除ボタン表示、2:選択ボタン表示
     */
    mode: {
      type: Number,
      default: 0
    },
    /**
     * 表示するレシピ件数(-1:制限なし)
     */
    limitCount: {
      type: Number,
      default: -1,
      required: true
    }
  },
  setup(props, context: SetupContext) {
    NativeClient.sendDebugLog("CommonRecipeList setup");
    /**
     * レシピ押下時に recipeId と type を通知する
     */
    const selectRecipe = (recipeId: number, type: string) => {
      context.emit("select-recipe", recipeId, type);
    };
    /**
     * レシピの選択チェックボックスの選択を通知する
     */
    const selectCheck = (recipeId: number, groupId: number, isCheck: boolean) => {
      context.emit("select-check", recipeId, groupId, isCheck);
    };
    /**
     * レシピの削除の選択を通知する
     */
    const selectDelete = (recipeId: number) => {
      context.emit("select-delete", recipeId);
    };
    /**
     * レシピのタグ押下時に tag を通知する
     */
    const selectRecipeTag = (id: number, name: string) => {
      context.emit("select-tag", id, name);
    };
    /**
     * レシピリストを取得する
     */
    const getRecipes = (recipes: Array<CommonRecipe>) => {
      if (recipes != null) {
        if (props.limitCount != -1) {
          return recipes.slice(0, props.limitCount);
        } else {
          return recipes;
        }
      } else {
        return null;
      }
    };

    return {
      selectRecipe,
      selectCheck,
      selectDelete,
      selectRecipeTag,
      getRecipes
    };
  }
});
